import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import { AddCover, SelectCover } from 'app/src/components/CardCoverChooser';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';

const PopOver = require('app/scripts/views/lib/pop-over');
const format = forNamespace('view title');

export const toggleCardCoverChooserPopover = ({
  elem,
  cardId,
}: {
  elem: Element;
  cardId: string;
}) => {
  const addCover = (
    <ComponentWrapper key="add-cover">
      <AddCover
        cardId={cardId}
        navigateToSelectCover={() => PopOver.popView()}
      />
    </ComponentWrapper>
  );

  const navigateToAddCover = () => {
    PopOver.pushView({
      getViewTitle: () => format('add-cover'),
      reactElement: addCover,
      displayType: 'mod-card-cover-chooser',
    });
  };

  const selectCover = (
    <ComponentWrapper key="select-cover">
      <SelectCover
        {...{
          cardId,
          navigateToAddCover,
        }}
      />
    </ComponentWrapper>
  );

  PopOver.toggle({
    elem,
    getViewTitle: () => format('cover'),
    reactElement: selectCover,
  });
};
